import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth';
import { adminCanAccess } from './lib/adminAccess';
import { PageLoader } from './components/ui';

export function RequireAuth({
  children,
  role,
  adminModule,
}: {
  children: React.ReactNode;
  role?: string | string[];
  /** When set with role=admin, blocks the route if the admin lacks this module. */
  adminModule?: string;
}) {
  const { me, loading } = useAuth();
  const location = useLocation();

  if (loading) return <PageLoader />;
  if (!me) return <Navigate to="/login" replace />;

  if (
    me.role === 'clinic_staff'
    && (me.needsClinicOnboarding || me.mustChangePassword)
    && !location.pathname.startsWith('/clinic/onboarding')
  ) {
    return <Navigate to="/clinic/onboarding" replace />;
  }

  if (role) {
    const allowed = Array.isArray(role) ? role : [role];
    if (!allowed.includes(me.role)) return <Navigate to="/" replace />;
  }

  if (adminModule && me.role === 'admin' && !adminCanAccess(me, adminModule)) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
}
